<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Empleados</h4>
            <div class="small text-muted">Panel de control de todos los empleados</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <b-row>
            <b-col md="4">
              <Widget :configWidget="configWidget" reference="indicator_total_employee" :hasAccess="configWidget.elements.indicatorTotalEmployee" />              
              <Widget :configWidget="configWidget" reference="pie_employee_category" :hasAccess="configWidget.elements.pieEmployeVsCategory" />                            
            </b-col>
            <b-col md="8">
              <Widget :configWidget="configWidget" reference="bar_hours_working_employee" :hasAccess="configWidget.elements.barHoursWorkingEmployee" />              
            </b-col>
          </b-row>
        </b-col>  
        <b-col md="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.employee">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openEmployee()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Empleado</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración del legajo de cada empleado
              </p>
            </b-list-group-item>
          </b-list-group>      

          <b-list-group class="mb-1" v-if="configSubView.elements.category">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCategory()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Categorias</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de las categorias de empleados
              </p>
            </b-list-group-item>
          </b-list-group>     
          
          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          elements: { 
            pieEmployeVsCategory: true,
            indicatorTotalEmployee: true,
            barHoursWorkingEmployee: true,
          }
        },
        configSubView: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            employee: true,
            category: true,
            php_custom: true,
          }
        },                
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */
      this.configWidget.elements.pieEmployeVsCategory = Helper.hasAccessWidget(this.configWidget, 'pie_employee_category')
      this.configWidget.elements.indicatorTotalEmployee = Helper.hasAccessWidget(this.configWidget, 'indicator_total_employee')
      this.configWidget.elements.barHoursWorkingEmployee = Helper.hasAccessWidget(this.configWidget, 'bar_hours_working_employee')
      /* Fin configuracion */

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.employee = Helper.showAccessView(this.configSubView, 'crudEmployee')      
      this.configSubView.elements.category = Helper.showAccessView(this.configSubView, 'crudCategory')      
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */                      
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openEmployee() {
        this.$router.push({ name: 'EmployeeStaffCrudEmployee' })
      },    
      openCategory() {
        this.$router.push({ name: 'EmployeetStaffCrudCategory' })
      },        

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.EMPLEADOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }             
    }    
   
  }
</script>

<style>

</style>
